import Manage from './Manage'

export default {
  Manage
}



// WEBPACK FOOTER //
// ./src/components/Credits/index.js